module.exports = __webpack_public_path__ + "img/Error.97695406.png";